import React from 'react'
import { getEleArray, getAttrValue, formatDateMDY } from 'helpers/Helpers';

export default function Inquiries({inquiries}) {
	//console.log("inquiries: ", inquiries);
	var inqs = inquiries;
	

	return (
		<div className='w-full flex flex-col'>
			<div className='header-bar'>
				<div className='header-text'>Inquiries</div>
			</div>
			<div className='w-full flex flex-col text-xs font-bold'>
				<div className='w-full flex flex-row border-2'>
					<div className='w-[348px] pl-2 border-r-2'>Inquirer Name</div>
					<div className='w-[130px] pl-2 border-r-2'>Inquiry Date</div>
					<div className='w-[200px] pl-2 border-r-2'>Repository</div>
					<div className='w-[390px] pl-2'>Subscriber Code</div>
				</div>
				<div className='pt-2'>
					{
						inqs.length === 0 &&
						<div className='pl-4 py-2 text-2xl font-semibold'>NO INQUIRIES</div>
					}
					{
						inqs.length > 0 &&
							inqs.map((inq, i) => {
								return (
								<Inquiry key={i} inq={inq} />
								)
							})
					}
				</div>
			</div>
		</div>
	)
}

function Inquiry({inq}) {
	//console.log("inq: ", inq);
	var name = getAttrValue(inq, "_Name");
	var date = formatDateMDY(getAttrValue(inq, "_Date"));
	var reps = getEleArray(inq, "CREDIT_REPOSITORY");
	//console.log("reps: ", reps);

	return (
		<div className='w-full flex flex-col value pb-2'>
			{
				reps.map((rep, i) => {
					var src = getAttrValue(rep, "_SourceType");
					var code = getAttrValue(rep, "_SubscriberCode");
					return (
						<div key={i} className='w-full flex flex-row value'>
							{ i === 0 &&
							<>
								<div className='w-[340px] pl-2'>{name}</div>
								<div className='w-[130px] pl-2'>{date}</div>
							</>
							}
							{ i !== 0 &&
							<>
								<div className='w-[470px] pl-2'></div>
							</>
							}
							<div className='w-[200px] pl-2'>{src}</div>
							<div className='w-[390px] pl-2'>{code}</div>
						</div>
					)
				})
			}
		</div>
	)
}
